const TYPE_PROJECT = {
    DEFAULT: {
        NOT_STARTED: "notStarted",
        DOING: "doing",
        DONE: "done",
    },
    OTHER: "other",
};

export {TYPE_PROJECT};